<div class="flex flex-col gap-6">
	<h2>Pólizas</h2>

	@if (loading()) {
		<app-policies-table-skeleton
			[showProducer]="showProducer"
			[showUser]="false"
			class="w-full" />
	} @else {
		<app-policies-table
			[showUser]="false"
			[entities]="rows()"
			[showProducer]="showProducer"
			(viewDetail)="openDetail($event)"
			class="w-full" />

		<app-pagination
			[paginationStore]="paginationStore"
			(pageChange)="changePage()" />
	}
</div>
